import React from "react";
import { Provider } from "react-redux";
import { store } from "../../redux/store";
import { BrowserRouter } from "react-router-dom";
import GeneratorPageTemplates from "./generatorPageTemplates";

export default function GeneratorPageTemplatesWrapper(props) {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <GeneratorPageTemplates {...props} />
      </BrowserRouter>
    </Provider>
  );
}